import { render } from "./FrameSettings.vue?vue&type=template&id=d9593bb6"
import script from "./FrameSettings.vue?vue&type=script&lang=js"
export * from "./FrameSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__